module.exports = __webpack_public_path__ + "img/assign.51af2f26.svg";